import { createSvgIcon } from '@mui/material/utils';

export const CopyToClipboard = createSvgIcon(
  <svg viewBox="0 0 12 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 9H1.5V2.5C1.5 2.225 1.275 2 1 2C0.725 2 0.5 2.225 0.5 2.5V9C0.5 9.55 0.95 10 1.5 10H6.5C6.775 10 7 9.775 7 9.5C7 9.225 6.775 9 6.5 9ZM9 7V1C9 0.45 8.55 0 8 0H3.5C2.95 0 2.5 0.45 2.5 1V7C2.5 7.55 2.95 8 3.5 8H8C8.55 8 9 7.55 9 7ZM8 7H3.5V1H8V7Z" />
  </svg>,
  'CopyToClipboard',
);
